// extracted by mini-css-extract-plugin
export var isPrintedCell = "_xv-1";
export var printerIcon = "_xv-0";